import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { Toaster } from "@/components/ui/sonner";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import CitizenDashboard from "@/pages/citizen/CitizenDashboard";
import NewSubmissionPage from "@/pages/citizen/NewSubmissionPage";
import SubmissionDetailPage from "@/pages/citizen/SubmissionDetailPage";
import OperatorQueue from "@/pages/operator/OperatorQueue";
import OperatorReview from "@/pages/operator/OperatorReview";
import OperatorUserPage from "@/pages/operator/OperatorUserPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import AdminReamsPage from "@/pages/admin/AdminReamsPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (user.role === "admin") return <Navigate to="/admin/users" replace />;
  if (user.role === "operator") return <Navigate to="/operator" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />

          <Route path="/dashboard" element={<Protected roles={["citizen", "business"]}><CitizenDashboard /></Protected>} />
          <Route path="/submissions/new" element={<Protected roles={["citizen", "business"]}><NewSubmissionPage /></Protected>} />
          <Route path="/submissions/:id" element={<Protected><SubmissionDetailPage /></Protected>} />

          <Route path="/operator" element={<Protected roles={["operator", "admin"]}><OperatorQueue /></Protected>} />
          <Route path="/operator/review/:id" element={<Protected roles={["operator", "admin"]}><OperatorReview /></Protected>} />
          <Route path="/operator/user/:userId" element={<Protected roles={["operator", "admin"]}><OperatorUserPage /></Protected>} />

          <Route path="/admin/users" element={<Protected roles={["admin"]}><AdminUsersPage /></Protected>} />
          <Route path="/admin/reams" element={<Protected roles={["admin", "operator"]}><AdminReamsPage /></Protected>} />
          <Route path="/admin/settings" element={<Protected roles={["admin"]}><AdminSettingsPage /></Protected>} />

          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<RoleHome />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
